import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllServiceType = createAsyncThunk(
    'serviceTypeSection/getAllServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get('service-type/v1/get-all', params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// create department
export const CreateServiceType  = createAsyncThunk(
    'serviceTypeSection/createServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('service-type/v1/create', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const UpdateServiceType  = createAsyncThunk(
    'serviceTypeSection/updateServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put('service-type/v1/update', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const DeleteServiceType  = createAsyncThunk(
    'serviceTypeSection/deleteServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`service-type/delete-by-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ListOfUsersServiceType  = createAsyncThunk(
    'serviceTypeSection/listOfUsersServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`service-type/get-all-pageable-user/by-service-type-id/${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// list of all user not belong to department
export const GetAllNonServiceType  = createAsyncThunk(
    'serviceTypeSection/getAllNonServicetypeUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`service-type/get-all-users/who-dont-belong-to-service-type/by-service-type-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
